enum UpdateStatus {
  UpToDate = 'UpToDate',
  UpdatesAvailable = 'UpdatesAvailable',
  Vulnerable = 'Vulnerable',
  UpToDateWithOptionalUpdates = 'UpToDateWithOptionalUpdates',
  Unknown = 'Unknown'
}

export default UpdateStatus;
